import React from "react";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";

type DescriptionProps = {
  description: string;
  title: string;
};

const Description: React.FC<DescriptionProps> = ({ description, title }) => {
  const [showFullDescription, setShowFullDescription] = React.useState(false);

  const handleShowFullDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  // console.log("description");
  return (
    <div className="flex gap-4 w-full flex-col px-[42px] py-[23px] bg-white">
      <p className=" text-darkGreen font-Jakarta text-[14px] font-semibold uppercase  ">
        {title}
      </p>

      <div
        className=" text-[#596780] font-Jakarta font-normal text-base leading-8"
        dangerouslySetInnerHTML={{ __html: description }}
      />

      {/* {showFullDescription ? (
        <div className="flex flex-col gap-10 w-full ">
          <p className=" text-[#596780] font-Jakarta font-normal text-base leading-8 ">
            {description}
          </p>
          <p
            className="flex gap-2 text-midGreen text-base font-Jakarta font-semibold leading-6  cursor-pointer"
            onClick={() => handleShowFullDescription()}
          >
            Show less description
            <RiArrowDropUpLine size={25} color="#215759" />
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-10 w-full ">
          <p className=" text-[#596780] font-Jakarta font-normal text-base leading-8 ">
            {description.slice(0, 200)}...
          </p>
          {description.length > 100 && (
            <p
              className="flex gap-2 text-midGreen text-base font-Jakarta font-semibold leading-6  cursor-pointer"
              onClick={() => handleShowFullDescription()}
            >
              Show full description
              <RiArrowDropDownLine size={25} color="#215759" />
            </p>
          )}
        </div>
      )} */}
    </div>
  );
};

export default Description;
